import { useState } from "react";
import { useSelector } from "react-redux";
import { ANY, AGE_RANGE } from "helpers/constants";

export const compute = {
	urlToApiParam: (value) => {
		if (value === ANY || !value) return null;

		return Number(value);
	},
};

export const isValid = (value) => {
	if (value === "") {
		return true;
	}

	const valueAsNumber = Number(value);

	return (
		Number.isInteger(valueAsNumber) &&
		valueAsNumber >= AGE_RANGE.MIN &&
		valueAsNumber <= AGE_RANGE.MAX
	);
};

const useFilterAgeRange = ({ initial }) => {
	const searchAge = useSelector((state) => state.globalUser.searchAge);

	const [selectedAge, setSelectedAge] = useState({
		from:
			initial.from === ANY
				? null
				: !initial || !initial.from
				? searchAge[0] ?? null
				: Number(initial.from),
		to:
			initial.to === ANY
				? null
				: !initial || !initial.to
				? searchAge[2] ?? null
				: Number(initial.to),
	});

	const isSelected = !(selectedAge.from === null && selectedAge.to === null);

	return {
		range: {
			min: AGE_RANGE.MIN,
			max: AGE_RANGE.MAX,
		},
		selected: selectedAge,
		setSelected: setSelectedAge,
		isSelected,
		compute,
		isValid,
	};
};

export default useFilterAgeRange;
